import { ErroApi } from './api';

/** No máximo três tentativas, apenas para indisponibilidade transitória ou rede. */
export function repetirQuery(falhas: number, erro: unknown): boolean {
  return falhas < 2 && erro instanceof ErroApi && (
    (erro.status === 503 && erro.code === 'servico_indisponivel') ||
    (erro.status === 0 && erro.code === 'rede')
  );
}

export function esperaQuery(tentativa: number): number {
  const base = tentativa === 0 ? 250 : 750;
  return base + Math.random() * 100;
}

export const opcoesQueries = {
  refetchOnWindowFocus: false,
  retry: repetirQuery,
  retryDelay: esperaQuery,
};
